import { useEffect, useRef } from 'react';
import { getApiBaseUrl } from '../utils/chatIdentity';
import { openResilientEventSource } from '../utils/resilientEventSource';

const API_BASE_URL = getApiBaseUrl();
const FALLBACK_POLL_MS = 60000;
const EVENT_DEBOUNCE_MS = 300;

const STREAM_PATH = '/api/partner-dashboard/repair-requests/stream';

export default function useShopDashboardRequestUpdates({ enabled = true, onUpdate }) {
    const onUpdateRef = useRef(onUpdate);
    onUpdateRef.current = onUpdate;

    useEffect(() => {
        if (!enabled) return undefined;

        let debounceTimer = null;
        const refresh = () => onUpdateRef.current?.();
        const debouncedRefresh = () => {
            window.clearTimeout(debounceTimer);
            debounceTimer = window.setTimeout(refresh, EVENT_DEBOUNCE_MS);
        };

        refresh();

        // Refetch on every open, so a reconnect picks up whatever changed while offline.
        const closeStream = openResilientEventSource(`${API_BASE_URL}${STREAM_PATH}`, {
            onOpen: debouncedRefresh,
            listeners: { update: debouncedRefresh },
        });

        const fallbackIntervalId = window.setInterval(refresh, FALLBACK_POLL_MS);

        return () => {
            closeStream();
            window.clearTimeout(debounceTimer);
            window.clearInterval(fallbackIntervalId);
        };
    }, [enabled]);
}
